import React from 'react';

const StarRating = ({ rating, size = "text-lg", interactive = false, onRatingChange }) => {
  const stars = [1, 2, 3, 4, 5];

  const handleClick = (starValue) => {
    if (interactive && onRatingChange) {
      onRatingChange(starValue);
    }
  };

  return (
    <div className="flex items-center gap-1" role="img" aria-label={`Calificación: ${rating} de 5 estrellas`}>
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          className={`${size} ${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : ''}`}
          onClick={() => handleClick(star)}
          disabled={!interactive}
          aria-label={`${star} estrella${star !== 1 ? 's' : ''}`}
        >
          <span className="sr-only">{star} estrella{star !== 1 ? 's' : ''}</span>
          {star <= rating ? (
            <span className="text-yellow-400" aria-hidden="true">★</span>
          ) : (
            <span className="text-gray-300" aria-hidden="true">☆</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default StarRating;
